import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PageLayout from "../components/Layout/PageLayout";
import Header from "../components/Sections/Header";
import Products from "../components/Sections/Products";
import FullButton from "../components/Buttons/FullButton";

export default function Landing() {
  return (
    <PageLayout
      offsetTop={false}
      path="/"
      title="Finechek | Diagnostic Solutions & Medical Testing Equipment"
      description="Finechek offers top-quality diagnostic solutions, including the Finechek BCA-100 Biochemistry Analyzer, Softstyle Ultra glucose monitor, Finechek BGA 100 blood gas analyzer, and Hemoglobin Testing System."
    >
      <Header />
      <Products limit={3} showAllLink />
      <Teaser className="lightBg">
        <div className="container">
          <h2 className="font40 extraBold">About Finechek</h2>
          <p className="font15">
            Finechek (A) Systems provides scientific instruments, laboratory equipment,
            reagents and consumables to laboratories worldwide, engineered for
            efficiency, accuracy and safety.
          </p>
          <BtnRow>
            <Link to="/about"><FullButton title="Learn More" border /></Link>
            <Link to="/contact"><FullButton title="Contact Us" /></Link>
          </BtnRow>
        </div>
      </Teaser>
    </PageLayout>
  );
}

const Teaser = styled.section`
  padding: 70px 0;
  text-align: center;
  p {
    max-width: 700px;
    margin: 15px auto 30px auto;
    line-height: 1.6;
    color: #707070;
  }
`;
const BtnRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  a { width: 180px; }
  @media (max-width: 460px) {
    flex-direction: column;
    align-items: center;
  }
`;
